import React from "react";
import { useDrag, useDrop } from "react-dnd";
import cn from "classnames";
import "./DraggableRow.scss";

interface DragItem {
  type: "ROW";
  index: number;
}

interface DraggableRowProps {
  row: any;
  index: number;
  moveRow: (dragIndex: number, hoverIndex: number) => void;
}

const DraggableRow: React.FC<DraggableRowProps> = ({ index, moveRow, children }) => {
  const ref = React.useRef<HTMLTableRowElement>(null);

  const [, drop] = useDrop<DragItem, void, HTMLTableRowElement>({
    accept: "ROW",
    hover(item) {
      if (!ref.current) {
        return;
      }

      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      moveRow(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag<DragItem, unknown, { isDragging: boolean }>({
    item: { type: "ROW", index },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));

  const className = cn("bpmTableDraggableRow", {
    isDragging,
  });

  return (
    <span ref={ref} className={className}>
      {children}
    </span>
  );
};

export default DraggableRow;
